/**
 * 用户认证工具 - 使用 localStorage 替代 cookie
 */

const CUSTOMER_KEY = 'cms_customer'
const LOGIN_STATUS_KEY = 'cms_login_status'
const REMEMBER_ME_KEY = 'cms_remember_me'
const TOKEN_KEY = 'cms_token'

/**
 * 获取 token
 * @returns {string}
 */
export function getToken () {
  return localStorage.getItem(TOKEN_KEY) || ''
}

/**
 * 保存 token
 * @param {string} token
 */
export function setToken (token) {
  if (token) {
    localStorage.setItem(TOKEN_KEY, token)
  }
}

/**
 * 清除 token
 */
export function clearToken () {
  localStorage.removeItem(TOKEN_KEY)
}

/**
 * 获取当前用户信息
 * @returns {Object|null}
 */
export function getCustomer () {
  try {
    const str = localStorage.getItem(CUSTOMER_KEY)
    return str ? JSON.parse(str) : null
  } catch (e) {
    return null
  }
}

/**
 * 保存用户信息
 * @param {Object} customer
 * @param {boolean} rememberMe 是否记住我（长期保存）
 */
export function setCustomer (customer, rememberMe = false) {
  if (!customer) return
  localStorage.setItem(CUSTOMER_KEY, JSON.stringify(customer))
  localStorage.setItem(LOGIN_STATUS_KEY, '1')
  if (rememberMe) {
    localStorage.setItem(REMEMBER_ME_KEY, '1')
  } else {
    localStorage.setItem(REMEMBER_ME_KEY, '0')
  }
}

/**
 * 清除登录状态
 */
export function clearCustomer () {
  localStorage.removeItem(CUSTOMER_KEY)
  localStorage.setItem(LOGIN_STATUS_KEY, '0')
  clearToken()
}

/**
 * 是否已登录
 * @returns {boolean}
 */
export function isLogin () {
  const customer = getCustomer()
  return !!(customer && customer.id)
}

/**
 * 是否勾选记住我
 * @returns {boolean}
 */
export function isRememberMe () {
  return localStorage.getItem(REMEMBER_ME_KEY) === '1'
}

/**
 * 获取图片完整地址
 * @param {string} path
 * @returns {string}
 */
export function getImgUrl (path) {
  if (!path) return ''
  if (path.startsWith('http')) return path
  return process.env.VUE_APP_IMG_BASE_URL + path
}


export function getAvatarUrl (path) {
  if (!path) return ''
  if (path.startsWith('http')) return path
  return process.env.VUE_APP_BASE_URL + '/fast' + path
}

